import { useCallback, useState } from "react";

import { type ScenarioData } from "pages/app/scenario-analysis/types/scenario";
import { areScenariosReadyForRecalculation } from "pages/app/scenario-analysis/utils/scenarioValidation";

/** Whether a blocked recalculation is flagging incomplete years, and the one check every recalculation path runs. */
export const useRecalcValidation = (revealFirstIncompleteScenario: () => void) => {
  const [recalcAttempted, setRecalcAttempted] = useState(false);

  const flagIncompleteScenarios = useCallback(() => {
    setRecalcAttempted(true);
    revealFirstIncompleteScenario();
  }, [revealFirstIncompleteScenario]);

  const clearValidationErrors = useCallback(() => setRecalcAttempted(false), []);

  /** True when every scenario can run; otherwise flags the incomplete years and shows the first offending scenario. */
  const passesValidation = useCallback(
    (scenarios: ScenarioData[]): boolean => {
      if (areScenariosReadyForRecalculation(scenarios)) return true;
      flagIncompleteScenarios();
      return false;
    },
    [flagIncompleteScenarios]
  );

  return { recalcAttempted, flagIncompleteScenarios, clearValidationErrors, passesValidation };
};

export type RecalcValidation = ReturnType<typeof useRecalcValidation>;
